import TutorImage from "@/assets/img/today/horoscope/tutor_horoscope.webp"

import { TodayTimer } from "../today-timer"
import { HOROSCOPE_COUNTDOWN } from "../../config/horoscope-content"

/** "A Sign, Not a Sentence" closing block + next-sync timer. Ported from Horoscope HoroscopeCountdown. */
export function HoroscopeCountdown({ target }: { target?: string }) {
  return (
    <>
      <div className="mt-10 px-4">
        <h3 className="font-display text-2xl font-medium text-purple-light">
          {HOROSCOPE_COUNTDOWN.title}
        </h3>
        <div className="mt-3 flex items-center gap-4">
          <img src={TutorImage} alt="" className="size-14 shrink-0" />
          <p className="font-body text-base text-purple-light/70">
            {HOROSCOPE_COUNTDOWN.description}
          </p>
        </div>
      </div>

      <div className="mt-10 px-4">
        <div className="h-px w-full bg-purple-light/20" />
        <div className="mt-6 flex min-h-[51px] items-center gap-4">
          <p className="min-w-0 flex-1 font-body text-base text-purple-light/70">
            Come back tomorrow for your next horoscope
          </p>
          {target && <TodayTimer target={target} />}
        </div>
      </div>
    </>
  )
}
